import { select } from '@panel/commons/core/themev2';
import styled, { css } from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Button = styled.div`
  border: 1px solid ${select('neutralDarkGrayII')};
  color: ${select('neutralDarkGrayII')};
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-size: 27px;
  cursor: pointer;
  ${({ isDisabled }) => {
    return isDisabled
      ? css`
          border: 1px solid ${select('neutralMediumGray')};
          color: ${select('neutralMediumGray')};
          cursor: not-allowed;
        `
      : css`
          &:hover {
            background-color: ${({ selected }) => (!selected ? select('neutralGray') : 'none')};
          }
        `;
  }}
`;

const Count = styled.div`
  font-style: normal;
  font-weight: 400;
  width: 36px;
  text-align: center;
`;

const CounterContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export { Container, Button, Count, Label, CounterContainer };
